import type { ResolvedPageMetadata } from "./seo-data";

const setMeta = (attribute: "name" | "property", key: string, value: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.append(element);
  }
  element.content = value;
};

const setCanonical = (url: string | null) => {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!url) {
    element?.remove();
    return;
  }
  if (!element) {
    element = document.createElement("link");
    element.rel = "canonical";
    document.head.append(element);
  }
  element.href = url;
};

const setPageStructuredData = (metadata?: ResolvedPageMetadata) => {
  const id = "page-seo-structured-data";
  let element = document.getElementById(id) as HTMLScriptElement | null;
  if (!metadata) {
    element?.remove();
    return;
  }
  if (!element) {
    element = document.createElement("script");
    element.id = id;
    element.type = "application/ld+json";
    document.head.append(element);
  }
  element.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: metadata.title,
    description: metadata.description,
    url: metadata.canonicalUrl,
    isPartOf: { "@type": "WebSite", name: "Harmony of Soul", url: "https://harmonyofsoul.web.app/" },
  });
};

export const updateDocumentMetadata = (metadata?: ResolvedPageMetadata) => {
  const title = metadata?.title ?? "Page not found | Harmony of Soul";
  const description = metadata?.description ?? "The requested page could not be found.";
  const image = metadata?.socialImage ?? "https://harmonyofsoul.web.app/hos_logo_512x512.png";

  document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "robots", metadata && !metadata.noIndex ? "index,follow,max-image-preview:large" : "noindex,follow");
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:image", image);
  setMeta("property", "og:url", metadata?.canonicalUrl ?? window.location.href);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", image);
  setCanonical(metadata && !metadata.noIndex ? metadata.canonicalUrl : null);
  setPageStructuredData(metadata);
};
